/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconButton } from "@mui/material";
import cn from "clsx";
import { ReactComponent as ArrowLeft } from "cms/assets/icons/arrow-left.svg";
import { formatDate } from "cms/utils/format-date";

const PermitDetails = (props) => {
    const permit = props?.permit ?? {};
    const goBackHandler = props?.goBackHandler;
    const permit_description = permit?.permit_description;
    const permit_number = permit?.permit_number;
    const main_address = permit?.main_address;
    const issue_date = permit?.issue_date;
    const permit_type = permit?.permit_type;
    const permit_status = permit?.permit_status;
    const valuation_value = permit?.valuation_value;
    const contact_company_name = permit?.contact_company_name;
    const contact_first_name = permit?.contact_first_name;
    const contact_middle_name = permit?.contact_middle_name;
    const contact_last_name = permit?.contact_last_name;

    const handleBackButtonClick = () => {
        goBackHandler();
    };

    const permitStatusCircleClassName = cn(
        "permit-status-circle",
        permit_status?.toLowerCase()
    );

    return (
        <div className="permit-details">
            <div className="permit-display-header">
                <div className="permit-display-title">
                    <IconButton aria-label="left-arrow" onClick={handleBackButtonClick}>
                        <ArrowLeft />
                    </IconButton>
                    <h3>{main_address || permit_number}</h3>
                    {permit_status && (
                        <div className="permit-status">
                            <div className={permitStatusCircleClassName}></div>
                            <span>{permit_status}</span>
                        </div>
                    )}
                </div>
            </div>
            <div className="permit-display-content">
                <div className="permit-info">
                    <strong>Permit ID</strong>
                    {permit_number}
                </div>
                <div className="permit-info">
                    <strong>Permit Number</strong>
                    {permit_number}
                </div>
                <div className="permit-info">
                    <strong>Description</strong>
                    {permit_description}
                </div>
                <div className="permit-info">
                    <strong>Permit Type</strong>
                    {permit_type}
                </div>
                <div className="permit-info">
                    <strong>Valuation</strong>
                    {valuation_value}
                </div>
                <div className="permit-info">
                    <strong>Issue Date</strong>
                    {formatDate(new Date(issue_date), "YYYY/MM/DD")}
                </div>
                <div className="permit-info">
                    <strong>Contact</strong>
                    {contact_company_name} <br></br>
                    {contact_first_name} {contact_middle_name} {contact_last_name}
                </div>
            </div>
        </div>
    );
};

export { PermitDetails };
